export const popups: Record<string, string> = {
	popup_recharging: "Recarregando",
	popup_jetpack_noSafeSpot: "Sem local seguro para pousar",
};
